import AccountSettingsService from '../services/AccountSettingsService';
import Common from './common'
import Vue from 'vue'
import _ from 'lodash'

const state = {
    orgContacts: []
}
const getters = {
    getOrgContacts(state) { return state.orgContacts; }
}

const mutations = {
    initialize(state) {
        Vue.set(state, 'orgContacts', [])
    },
    setOrgContacts(state, orgContacts) {
        Vue.set(state, 'orgContacts', orgContacts)
    }
}

const actions = {
    initialize ({commit}) {
        commit('initialize')
    },
    async getOrgContacts() {
        let response = await AccountSettingsService.getOrgContacts()
        return response.data
    },
    async updateOrgContact({}, {orgContact, patchObject}) {
        try {
            let response = await AccountSettingsService.updateOrgContact(orgContact, patchObject)
            return true
        } catch (e) {
            return false
        }
    },
    async insertOrgContact({}, orgContact) {
        try {
            let response = await AccountSettingsService.insertOrgContact(orgContact)
            return true
        } catch (e) {
            return false
        }
    },
    async deleteOrgContact({}, orgContact) {
        try {
            let response = await AccountSettingsService.deleteOrgContact(orgContact)
            return true
        } catch (e) {
            return false
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}